import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { fetchLiveLocations } from "../api/analyticsApi";

interface LocationData {
  lat: number;
  lng: number;
  count: number;
  country?: string;
  city?: string;
}

const LeafletAnalyticsMap: React.FC = () => {
  const [locations, setLocations] = useState<LocationData[]>([]);

  useEffect(() => {
    const loadLocations = async () => {
      try {
        const data = await fetchLiveLocations();
        
        // If no real data, use mock data for development
        const displayData = data.length > 0 
          ? data 
          : [
              { lat: 40.7128, lng: -74.0060, count: 3, country: 'USA', city: 'New York' },
              { lat: 34.0522, lng: -118.2437, count: 2, country: 'USA', city: 'Los Angeles' }
            ];
            
        setLocations(displayData.filter((loc: LocationData) => loc.lat && loc.lng));
      } catch (error) {
        console.error("Error loading locations:", error);
      }
    };

    loadLocations();
    const interval = setInterval(loadLocations, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <MapContainer
      center={[20, 0]}
      zoom={2.2}
      style={{ height: "100%", width: "100%", borderRadius: "12px" }}
      scrollWheelZoom={false}
    >
      <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />

      {locations.map((location, index) => (
        <CircleMarker
          key={index}
          center={[location.lat, location.lng]}
          radius={Math.sqrt(location.count) * 4}
          fillColor="rgba(0, 122, 255, 0.6)"
          color="rgba(0, 122, 255, 0.8)"
          weight={1}
          fillOpacity={0.6}
        >
          <Tooltip direction="top" offset={[0, -5]} opacity={1}>
            <div style={{ minWidth: '120px' }}>
              {location.city && <strong>{location.city}, {location.country}</strong>}
              {!location.city && location.country && <strong>{location.country}</strong>}
              {!location.city && !location.country && <strong>Unknown location</strong>}
              <div>{location.count} active visitor{location.count > 1 ? 's' : ''}</div>
            </div>
          </Tooltip>
        </CircleMarker>
      ))}
    </MapContainer>
  );
};

export default LeafletAnalyticsMap;